angular.module('ikeweb.locale', ['ikeweb.shared.input', 'ikeweb.user', 'ikeweb.shared.messaging', 'ikeweb.shared.i18n', 'LocalStorageModule']);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/module.js
// module id = 477
// module chunks = 0